import { HttpClient } from "@angular/common/http"
import { inject, Injectable } from "@angular/core"
import { Observable } from "rxjs"
import { EnvironmentService } from "../environment/environment.service"

export interface ContactInquiryPayload {
  form_type: "contact_inquiry"
  origin: "frontend"
  name: string
  email: string
  message: string
  message_type?: string
}

export interface SubscriberLeadPayload {
  form_type: "subscriber_lead"
  origin: "frontend"
  name: string
  email: string
  company_name: string
  phone: string
}

@Injectable({
  providedIn: "root",
})
export class PublicFormsService {
  private readonly http = inject(HttpClient)
  private readonly environment = inject(EnvironmentService)

  private readonly API_URL = `${this.environment.API_URL}v1/public/form-submissions`

  submitInquiry(payload: { name: string; email: string; message: string; message_type?: string }): Observable<unknown> {
    const body: ContactInquiryPayload = {
      form_type: "contact_inquiry",
      origin: "frontend",
      ...payload,
    }
    return this.http.post(this.API_URL, body)
  }

  submitLead(payload: { name: string; email: string; company_name: string; phone: string }): Observable<unknown> {
    const body: SubscriberLeadPayload = {
      form_type: "subscriber_lead",
      origin: "frontend",
      ...payload,
    }
    return this.http.post(this.API_URL, body)
  }
}
